/**
 * @file Filters
 */

import { gsap } from 'gsap';

/**
 * Filters component
 */
const vFilters = () => {
	const filters = document.querySelector( '.v-filters' );

	if ( ! filters ) {
		return;
	}

	const trigger     = filters.querySelector( '.v-filters__trigger' );
	const filterWrap  = filters.querySelector( '.v-filters__filter-wrap' );
	const filterInner = filters.querySelector( '.v-filters__filter-inner' );

	trigger.addEventListener( 'click', () => {
		let opening = false;
		if ( trigger.classList.contains( 'v-filters__trigger--active' ) ) {
			trigger.classList.remove( 'v-filters__trigger--active' );
		} else {
			opening = true;
			trigger.classList.add( 'v-filters__trigger--active' );
		}

		gsap.set( filterWrap, { display: 'block' } );
		gsap.to( filterWrap, {
			height:   opening ? filterInner.getBoundingClientRect().height : 0,
			duration: .3,
			onComplete() {
				if ( opening ) {
					filterWrap.classList.add( 'v-filters__filter-wrap--active' );
				} else {
					filterWrap.classList.remove( 'v-filters__filter-wrap--active' );
				}
				filterWrap.removeAttribute( 'style' );
			},
		} );
	} );
};

export default vFilters;
